import { Component, OnInit } from '@angular/core';
import { Request } from '../_service/request';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Component({
  selector: 'app-prop-listing',
  templateUrl: './prop-listing.component.html',
  styleUrls: ['./prop-listing.component.scss']
})
export class PropListingComponent implements OnInit {

  constructor(
    private request: Request,
    private router: Router,
  ) { }
  isEnabled = false;
  propertyListData: any;

  server_url = this.request.server_url;
  ngOnInit(): void {
    this.getPropListingDetails()
  }

  async getPropListingDetails() {
    let temp = this.request.get_structure('getAllPropListing', 'format')
    temp = await this.request.post(0, 'getAllPropListing', temp);
    console.log(temp);
    if (temp[0] == 200) {
      this.isEnabled = true
      this.propertyListData = temp[1]['response']['data']['property_list']
    } else {
      this.isEnabled = false
    }
  }

  viewPropDetails(data) {
    console.log(data)
    window.scroll(0, 0);
    this.router.navigateByUrl("/desc?pid=" + data);
  }
}
